module.exports = __webpack_public_path__ + "static/img/project_logo_icmarc.ca46eae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project_logo_icmarc.png
// module id = 748
// module chunks = 1